
namespace GeniuzPOS.CustomReport {

    @Serenity.Decorators.registerClass()
    export class ReportCusSaleReportGrid extends Serenity.EntityGrid<ReportCusSaleReportRow, any> {
        protected getColumnsKey() { return ReportCusSaleReportColumns.columnsKey; }
        protected getDialogType() { return ReportCusSaleReportDialog; }
        protected getIdProperty() { return ReportCusSaleReportRow.idProperty; }
        protected getInsertPermission() { return ReportCusSaleReportRow.insertPermission; }
        protected getLocalTextPrefix() { return ReportCusSaleReportRow.localTextPrefix; }
        protected getService() { return ReportCusSaleReportService.baseUrl; }

        public shopid : string;
        // public shopid : string;

        // constructor(container: JQuery) {
        //     super(container);

        //     this.shopid = QRreport.QRywcSpecRow.getLookup().itemById["120"].ShopId ?? null;
        // }

        protected createToolbarExtensions() {
            super.createToolbarExtensions();

            this.slickGrid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());

            var groupingMixin = new Serenity.DraggableGroupingMixin({
                grid: this
            });

            // setting ShipCountry, ShipCity columns as initially grouped for this sample
            // you could add [GroupOrder(1)] to ShipCountry, and [GroupOrder(2)] to ShipCity
            // in OrderColumns.cs instead (recommended way)
            groupingMixin.plugin.setDroppedGroups(["BrandName"]);
            // groupingMixin.plugin.setDroppedGroups(["PosId"]);

        }
        protected markupReady() {
            super.markupReady();

            // expanding all level 0 (Country) and level 1 (City) groups initially
            this.view.expandAllGroups(0);
            // this.view.expandAllGroups(1);
            // this.view.expandAllGroups(2);
        }

        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            opt.showFooterRow = true;
            opt.groupingPanel = true;
            return opt;
        }

        protected createSlickGrid() {
            var grid = super.createSlickGrid();


            grid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());

            this.view.setSummaryOptions({
                aggregators: [

                    new Slick.Aggregators.Sum('QtySold'),
                    new Slick.Aggregators.Sum('ExPrice'),
                    new Slick.Aggregators.Sum('DisCount'),
                    new Slick.Aggregators.Sum('NetSale'),
                    new Slick.Aggregators.Sum('NetSalesExVat'),
                    new Slick.Aggregators.Sum('CostOfGoods'),
                    new Slick.Aggregators.Sum('VatAmt'),
                    new Slick.Aggregators.Sum('GrossMargin'),
                    new Slick.Aggregators.Sum('DiscountCom'),
                    new Slick.Aggregators.Sum('DiscountSup'),
                    new Slick.Aggregators.Sum('DiscountMb'),
                    new Slick.Aggregators.Sum('DiscountBill'),
                    new Slick.Aggregators.Sum('DiscountSum'),
                    new Slick.Aggregators.Sum('NetMargin')
                ]
            });
           

            return grid;
        }

        // private getFilterDescriptions(grid: Serenity.DataGrid<any, any>, gridColumns: Slick.Column[], options: GeniuzPOS.Common.Helpers.Report1102PdfOptions): any {
        //     // let request = Q.deepClone(grid.view.params) as Serenity.ListRequest;
        //     // let columns = Object.keys(options.columnStyles)

            
        //     let descriptions: string[] = [];

        //     if(!Q.isEmptyOrNull(this.shopid)){
        //         descriptions.push("ระบุร้านค้า"+this.shopid)
        //     }else{
        //         descriptions.push("ไม่ระบุร้านค้า")
        //     }
                
           
            
        //     return [descriptions, gridColumns];
        // }

        protected getButtons() {
            var buttons = super.getButtons();

            // remove first button (Add button)
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            // buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'column-picker-button'), 1)

            // Add buttons import excel, pdf
            buttons.push(Common.Helpers.ExcelExportHelper.createToolButton({
                grid: this,
                service: ReportCusSaleReportService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));

            // let reportTitle = 'Sale Report'

            // // Max page width = 277 /// ข้อมูลหน้านี้ไม่พอ
            // let columnStyles: { [dataKey: string]: GeniuzPOS.Common.Helpers.AutoTableStyles } = {
            //     0: { field: "BrandName", title: "BrandName", cellWidth: 16 ,overflow: 'linebreak'},
            //     1: { field: "SupplierId", title: "VenderCode", cellWidth: 15, halign: 'center' , overflow: 'linebreak' },
            //     2: { field: "SuplierName", title: "VenderName", cellWidth: 24,overflow: 'linebreak'},
            //     3: { field: "Category1", title: "Department", cellWidth: 24 ,overflow: 'linebreak'},
            //     4: { field: "Category2", title: "Category", cellWidth: 24 ,overflow: 'linebreak'},
            //     5: { field: "Category3", title: "Sub-Category", cellWidth: 24 ,overflow: 'linebreak'},
            //     6: { field: "SkuCode", title: "ItemCode", cellWidth: 15, halign: 'center' },
            //     7: { field: "PluCode", title: "Plu", cellWidth: 15, halign: 'center' },
            //     8: { field: "SkuDesc", title: "ItemName", cellWidth: 25 ,overflow: 'linebreak'},

            //     9: { field: "QtySold", title: "History Sales 6 Month (Qty)", cellWidth: 20, halign: 'right' },
            //     10: { field: "ExPrice", title: "Average Sales/Month (Qty)", cellWidth: 20, halign: 'right'},
            //     11: { field: "DisCount", title: "On Hand Qty", cellWidth: 15, halign: 'right' },
            //     12: { field: "StkUnit", title: "Unit", cellWidth: 10  },
            //     13: { field: "NetSale", title: "CostAmount", cellWidth: 15, halign: 'right' },
            //     14: { field: "AvgPrice", title: "SellPrice1", cellWidth: 15, halign: 'right' },

            //     15: { field: "NetSalesExVat", title: "History Sales 6 Month (Qty)", cellWidth: 20, halign: 'right' },
            //     16: { field: "CostOfGoods", title: "Average Sales/Month (Qty)", cellWidth: 20, halign: 'right'},
            //     17: { field: "VatAmt", title: "On Hand Qty", cellWidth: 15, halign: 'right' },
            //     18: { field: "GrossMargin", title: "Unit", cellWidth: 10  },
            //     19: { field: "GrossPc", title: "CostAmount", cellWidth: 15, halign: 'right' },
            //     20: { field: "DiscountCom", title: "SellPrice1", cellWidth: 15, halign: 'right' },
            //     21: { field: "DiscountSup", title: "SellPrice1", cellWidth: 15, halign: 'right' },
            //     22: { field: "DiscountMb", title: "DiscountMb", cellWidth: 15, halign: 'right' },
            //     23: { field: "DiscountBill", title: "DiscountBill", cellWidth: 15, halign: 'right' },
            //     24: { field: "DiscountSum", title: "DiscountSum", cellWidth: 15, halign: 'right' },
            //     25: { field: "NetMargin", title: "NetMargin", cellWidth: 15, halign: 'right' },
            //     26: { field: "NetGp", title: "NetMargin", cellWidth: 15, halign: 'right' }
            // }

           

           

            // buttons.push(GeniuzPOS.Common.Helpers.Report1311PdfHelper.createToolButton({
            //     grid: this,
            //     onViewSubmit: () => this.onViewSubmit(),
            //     reportTitle: reportTitle,
            //     separator: true,
            //     pageNumbers: true,
            //     onCreateFilterDescriptions: (grid: Serenity.DataGrid<any, any>, gridColumns: Slick.Column[], options: GeniuzPOS.Common.Helpers.Report1102PdfOptions) => this.getFilterDescriptions(grid, gridColumns, options),
            //     columnStyles: columnStyles,
            //     // groupHeader: {
            //     //     0: { title: 'หน่วย', startX: 125, width: 70 }
            //     // },
            //     hideGroupColumn: false,
            //     theme: 'plain',
            //     showTableHead: 'everyPage',
            //     isCustomHeader: true,

            //     //reportTitle: "This is report title",
            //     titleTop: 7,
            //     titleFontSize: 11,
            //     fileName: "ThisIsTheFileName",
            //     //pageNumbers: true,
            //     columnTitles: {
            //         'OriginalColumn': 'OCol.',
            //     },
            //     tableOptions: {
            //         // head: ,
            //         headerStyles: {
            //             halign: 'center'
            //         },
            //         columnStyles: {
            //             OriginalColumn: {
            //                 // columnWidth: 25,
            //                 halign: 'center'
            //             }
            //         }
            //     }
            // }));

            
            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/QRreport/QRywcSpec#QRreport.QRywcSpecReportCusSaleReport/edit/120';
                        return false;
                    },
                }
            );
            return buttons;
        }

        
    }
}